import get from 'lodash/get';
import Geohash from 'latlon-geohash';
import {
  SET_BILLER_LIST,
  SET_BILLER_PREFIX,
  SET_LOADING,
  SET_BILLER,
  SET_SERVICE,
  SET_CHECKOUT,
  UPDATE_CHECKOUT_PARAM,
  SET_USER_AGREEMENTS,
} from 'redux/actions/types';
import { initSplit, getTreatment } from 'utils/SplitService';
import { JsBridge } from 'utils';

import { trackEvent } from '../../utils/Mixpanel';
import apiService from '../../utils/ApiService';

const { billerService } = apiService.getInstance();

export const setListBiller = data => ({
  type: SET_BILLER_LIST,
  payload: data,
});

export const setLoading = isLoading => ({
  type: SET_LOADING,
  payload: isLoading,
});

export const setService = data => ({
  type: SET_SERVICE,
  payload: data,
});

export const setBiller = data => ({
  type: SET_BILLER,
  payload: data,
});

export const setPrefix = data => ({
  type: SET_BILLER_PREFIX,
  payload: data,
});

export const setCheckout = data => ({
  type: SET_CHECKOUT,
  payload: data,
});

export const updateCheckoutParam = param => ({
  type: UPDATE_CHECKOUT_PARAM,
  param,
});

export const setUserAgreements = data => ({
  type: SET_USER_AGREEMENTS,
  payload: data,
});

export const getBiller = id => async dispatch => {
  let resolve = null;
  try {
    dispatch(setLoading(true));
    const response = await billerService.get(`billers/${id}`);
    resolve = response;
    if (response.status === 200) {
      dispatch(setBiller({}));
      const { payload } = response.data;
      dispatch(setBiller(payload));
      dispatch(setService(payload.service));
    } else {
      dispatch(setBiller({}));
    }
    dispatch(setLoading(false));
  } catch (error) {
    resolve = error;
    dispatch(setBiller({}));
    dispatch(setLoading(false));
  }
  return resolve;
};

export const getListBiller = params => dispatch => {
  // Set Activity To Proccess
  dispatch(setLoading(true));
  // Do Load Data Biller List
  billerService
    .get('billers', { params })
    .then(response => {
      if (response.status === 200) {
        const { payload } = response.data;
        dispatch(setListBiller(payload));
      } else {
        dispatch(setListBiller([]));
      }
      dispatch(setLoading(false));
    })
    .catch(() => {
      dispatch(setListBiller([]));
      dispatch(setLoading(false));
    });
};

const onGetBillerSuccess = (billerList, dispatch, geohash) => {
  let billerResult = [];
  initSplit((status, client) => {
    if (status === 'ready') {
      billerList.forEach(biller => {
        const { treatment, config } = getTreatment(
          client,
          `allbiller_${biller.public_id.toLowerCase().replace('-', '_')}`,
        );
        const splitGeohash = JSON.parse(config || '{"geohash": "empty"}')
          .geohash;

        const showDefault = treatment === 'control' || treatment === 'on';
        const showByLocation =
          treatment === 'location' && splitGeohash === geohash;

        if (showDefault || showByLocation) {
          billerResult.push(biller);
        }
      });
    } else if (status === 'timeout') {
      billerResult = billerList;
    }

    dispatch(setListBiller(billerResult));
    dispatch(setLoading(false));
  });
};

export const getListBillerByService = (id, params) => dispatch => {
  // Set Activity To Proccess
  dispatch(setLoading(true));
  // Do Load Data Biller List
  return billerService
    .get(`services/${id}/billers`, { params })
    .then(response => {
      let result;
      if (response.status === 200) {
        const { payload } = response.data;
        const billerList = payload;

        if (window.IS_IN_SKYWALKER && !window.IS_IN_BROWSER_DEBUG) {
          document.addEventListener(
            'AlipayJSBridgeReady',
            () => {
              JsBridge.call(
                'getDeviceInfo',
                { event: 'location' },
                locationResult => {
                  if (locationResult.success) {
                    const lat = parseFloat(
                      get(locationResult, 'data.gps.latitude'),
                    );
                    const long = parseFloat(
                      get(locationResult, 'data.gps.longitude'),
                    );
                    onGetBillerSuccess(
                      billerList,
                      dispatch,
                      Geohash.encode(lat, long, 4),
                    );
                  } else {
                    onGetBillerSuccess(billerList, dispatch);
                  }
                },
              );
            },
            false,
          );
        } else {
          onGetBillerSuccess(billerList, dispatch);
        }

        result = billerList;
      } else {
        result = [];
        dispatch(setListBiller([]));
        dispatch(setLoading(false));
      }

      return result;
    })
    .catch(() => {
      dispatch(setListBiller([]));
      dispatch(setLoading(false));
      return [];
    });
};

// @TODO remove fromGeneral
export const createCheckout = params => async dispatch => {
  let resolve = null;

  try {
    dispatch(setLoading(true));
    dispatch(updateCheckoutParam(params));

    const response = await billerService.post('checkout', params);
    // MOCK
    // IT WILL USEFULL IF CORE ENV UNSTABLE DONT DELETE
    // const response = {
    //   status: 200,
    //   data: {
    //     status: 'success',
    //     payload: {
    //       sales_order_id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    //       biller_id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    //       beneficiary_account_number: 'string',
    //       beneficiary_full_name: 'string',
    //       est_processed_time: '2021-11-29T08:17:41.376Z',
    //       transaction_amount: '10000',
    //       admin_fee: '999',
    //       total_amount: '10999',
    //       dana_payer_info: {
    //         is_kyc: true,
    //         balance: {
    //           currency: 'IDR',
    //           amount: '15000',
    //         },
    //         nickname: 'JONO',
    //       },
    //     },
    //   },
    // };
    // Check Status Request
    if (response.status === 200) {
      const { payload } = response.data;
      dispatch(setCheckout(payload));
      resolve = Promise.resolve(true);
    } else {
      dispatch(setCheckout({}));
      resolve = Promise.resolve(false);
    }

    dispatch(setLoading(false));
  } catch (error) {
    resolve = Promise.reject(error);

    const title = get(error, 'response.data.message.title', '');
    if (
      title !== 'AMOUNT_NOT_FOUND' &&
      title !== 'AMOUNT_AND_PAYER_INFO_NOT_FOUND'
    ) {
      dispatch(helper.trackError(error));
    }

    dispatch(setLoading(false));
  }
  return resolve;
};

export const requestPay = salesOrderId => async dispatch => {
  let resolve = null;
  try {
    dispatch(setLoading(true));
    const payUrl = `orders/${salesOrderId}/pay`;

    const response = await billerService.post(payUrl);
    // Check Status Request
    if (response.status === 200) {
      const { payload } = response.data;
      resolve = Promise.resolve(payload);
    } else {
      resolve = Promise.reject(response);
    }
    dispatch(setLoading(false));
  } catch (error) {
    resolve = Promise.reject(error);

    dispatch(helper.trackError(error));
    dispatch(setLoading(false));
  }
  return resolve;
};

export const trackError = error => dispatch => {
  const errorCode = get(error, 'response.code', 400);
  const errorMessage = get(
    error,
    'response.data.message.title',
    'Network Error',
  );

  dispatch(
    trackEvent(
      'Network Error',
      {
        'Error Code': errorCode,
        'Error Message': errorMessage,
      },
      false,
    ),
  );
};

export const getBillerPrefix = id => async dispatch => {
  let resolve = null;
  try {
    dispatch(setLoading(true));
    const params = {
      page_num: 1,
      page_size: 100,
    };
    const response = await billerService.get(`billers/${id}/prefix`, {
      params,
    });

    // Check Status Request
    if (response.status === 200) {
      const { payload } = response.data;
      resolve = Promise.resolve(payload);
      dispatch(setPrefix(payload));
    } else {
      resolve = Promise.reject(response);
    }
    dispatch(setLoading(false));
  } catch (error) {
    resolve = Promise.reject(error);
    dispatch(setLoading(false));
  }
  return resolve;
};

export const getBillerRecentTrx = id => async dispatch => {
  let resolve = null;
  try {
    dispatch(setLoading(true));
    const params = {
      biller_id: id,
    };
    const response = await billerService.get(`customer/orders/recent`, {
      params,
    });

    // Check Status Request
    if (response.status === 200) {
      const { payload } = response.data;
      const result = payload.map(item => ({
        id: item.id,
        icon: item.biller_icon_abs_url,
        name: item.biller_name,
        account: item.beneficiary_account_number,
        prefix: item.va_prefix,
        amount: parseInt(item.transaction_amount, 10),
      }));
      resolve = Promise.resolve(result);
    } else {
      resolve = Promise.resolve([]);
    }
    dispatch(setLoading(false));
  } catch (error) {
    resolve = Promise.resolve([]);
    dispatch(setLoading(false));
  }
  return resolve;
};

export const getLatestTNC = id => async dispatch => {
  let resolve = null;
  try {
    dispatch(setLoading(true));
    const response = await billerService.get(`tncs/${id}`);
    if (response.status === 200) {
      const { payload } = response.data;
      resolve = Promise.resolve(payload);
    } else {
      resolve = Promise.reject(response);
    }
    dispatch(setLoading(false));
  } catch (error) {
    resolve = Promise.reject(error);
    dispatch(setLoading(false));
  }
  return resolve;
};

export const getAgreementTNC = id => async dispatch => {
  let resolve = null;
  try {
    dispatch(setLoading(true));
    const response = await billerService.get(`customer/tncs/${id}/agreements`);
    if (response.status === 200) {
      const { payload } = response.data;
      dispatch(setUserAgreements(payload.agreements));
      resolve = Promise.resolve(payload.agreements);
    } else {
      resolve = Promise.reject(response);
    }
    dispatch(setLoading(false));
  } catch (error) {
    resolve = Promise.reject(error);
    dispatch(setLoading(false));
  }
  return resolve;
};

export const signatureAgreementTNC = (id, params) => async dispatch => {
  let resolve = null;
  try {
    dispatch(setLoading(true));
    const response = await billerService.post(
      `customer/tncs/${id}/agreements`,
      params,
    );
    if ([200, 201].includes(response.status)) {
      const { payload } = response.data;
      resolve = Promise.resolve(payload);
    } else {
      resolve = Promise.reject(response);
    }
    dispatch(setLoading(false));
  } catch (error) {
    resolve = Promise.reject(error);
    dispatch(setLoading(false));
  }
  return resolve;
};

export const helper = { trackError };
